// extracted by mini-css-extract-plugin
module.exports = {"container":"DropdownLink_container__ewo7m","dropDown":"DropdownLink_dropDown__Pjwgj","link":"DropdownLink_link__VKGoP"};